import styled from 'styled-components';

import { primitive } from '../../designTokens/primitives';
import { mediaQuery } from '../../globalStyles';

export const Wrapper = styled.li`
  list-style-type: none;
`;

export const LinkWrapper = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-decoration: none;
  border-radius: ${(p) => p.theme.token('border-radius-pattern-interactive')};
  color: ${(p) => p.theme.token('text-default')};
  padding: ${primitive.$spacing3} ${primitive.$spacing3} ${primitive.$spacing5};
  cursor: pointer;
  height: 100%;
  max-width: 150px;
  width: 40vw;
  background: ${(p) => p.theme.token('background-pattern')};
  border: 1px solid ${(p) => p.theme.token('border-color-default')};

  &:focus {
    outline: none;
    background: ${(p) => p.theme.token('background-focus')};
  }

  @media ${mediaQuery.tablet} {
    max-width: unset;
    width: 140px;
    background: none;
    border: none;
  }

  @media ${mediaQuery.desktopLarge} {
    width: 180px;
  }
`;

export const ImageContainer = styled.div`
  overflow: hidden;

  & > * {
    display: block;
    width: auto;
    object-fit: contain;
    object-position: center;
    max-height: 100px;
    margin: auto;

    @media ${mediaQuery.tablet} {
      max-height: 120px;
    }
    @media ${mediaQuery.desktopLarge} {
      max-height: 160px;
    }
  }
`;

export const Header = styled.div<{ hasCalories: boolean }>`
  margin: 0;
  padding-top: ${primitive.$spacing2};
  font: ${(p) => p.theme.token('text-style-item-description-header')};
  text-align: center;
  min-height: ${(p) => (p.hasCalories ? '0' : `60px`)};
  ${Wrapper}:hover & {
    color: ${(p) => p.theme.token('text-active')};
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CaloriesText = styled.div`
  font: ${(p) => p.theme.token('text-style-item-description-copy')};
  padding-top: ${primitive.$spacing2};
  text-align: center;
`;

export const RewardsChipWrapper = styled.div`
  padding-top: ${primitive.$spacing2};
`;
